import Vue from 'vue'
import VueRouter from 'vue-router'

import Mektup from "@/views/Mektup";
import Belgeler from "@/views/Belgeler";
import Kart from "@/views/Kart";
import AnaSayfa from "@/views/AnaSayfa";
import GirisYap from "@/views/GirisYap";
import OkunamayanKelimeler from "@/views/OkunamayanKelimeler";
import SoruDetay from "@/views/SoruDetay";
import Kisiler from "@/views/Kisiler";
import Kisi from "@/views/Kisi";
import Yardim from "@/views/Yardim";
import LatinceOsmanlica from "@/views/LatinceOsmanlica"
import YeniKampYeriEkle from "@/views/YeniKampYeriEkle"
import ToplamHaftalikRapor from "@/views/ToplamHaftalikRapor";
import KisiBazliHaftalikRapor from "@/views/KisiBazliHaftalikRapor";
import HaftalikToplamRaporGrafik from "@/views/HaftalikToplamRaporGrafik";
import HaftalikSaatselRapor from "@/views/HaftalikSaatselRapor";
import SorumluOlunanKisiler from "@/views/SorumluOlunanKisiler";
import Test from "@/views/Test";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'anasayfa',
    component: AnaSayfa
  },
  {
    path: '/giris-yap',
    name: 'girisyap',
    component: GirisYap
  },
  {
    path: '/mektup',
    name: 'mektup',
    component: Mektup
  },
  {
    path: '/belgeler',
    name: 'belgeler',
    component: Belgeler
  },
  {
    path: '/kart',
    name: 'kart',
    component: Kart
  },
  {
    path: '/okunamayan-kelimeler',
    name: 'okunamayankelimeler',
    component: OkunamayanKelimeler
  },
  {
    path: '/kisi-bazli-haftalik-rapor',
    name: 'kisiBazliHaftalikRapor',
    component: KisiBazliHaftalikRapor
  },
  {
    path: '/test',
    name: 'Test',
    component: Test
  },
  {
    path: '/haftalik-toplam-rapor',
    name: 'toplamHaftalikRapor',
    component: ToplamHaftalikRapor
  },
  {
    path: '/haftalik-toplam-rapor-gorsel',
    name: 'haftalikToplamRaporGrafik',
    component: HaftalikToplamRaporGrafik
  },
  {
    path: '/haftalik-saatsel-rapor/:haftaBaslangic',
    name: 'haftalikSaatselRapor',
    component: HaftalikSaatselRapor,
  },
  {
    path: '/sorudetay/:kelimeId',
    name: 'sorudetay',
    component: SoruDetay
  },
  {
    path: '/kisi/:id',
    name: 'kisi',
    component: Kisi
  },
  {
    path: '/kisiler',
    name: 'kisiler',
    component: Kisiler
  },
  {
    path: '/sorumlu-olunan-kisiler',
    name: 'sorumluOlunanKisiler',
    component: SorumluOlunanKisiler,
  },
  {
    path: '/latince-osmanlica',
    name: 'latinceosmanlica',
    component: LatinceOsmanlica
  },
  {
    path: '/yeni-kamp-yeri-ekle/',
    name: 'yenikampyeriekle',
    component: YeniKampYeriEkle
  },
  {
    path: '/yardım',
    name: 'yardım',
    component: Yardim
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
